var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('prk-select',{attrs:{"color":"aqua","label":_vm.$tc('general.course', 1),"includeBlank":true,"options":_vm.courseNames,"value":_vm.$route.query.course_name_id},on:{"input":function($event){return _vm.$emit('filter:course', $event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }